export const WIDGET_NOTIFICATION_COUNT = 5;
